var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Surface',{class:[
    'customer-import-modal',
    {
      '--mobilefullscreen': _vm.mobileFullScreen
    }
  ],style:(_vm.styleFullScreen),attrs:{"backgroundColor":"white"}},[_c(_vm.activeStepData.componentName,{tag:"component",attrs:{"customerImportFormData":_vm.customerImportFormData,"stepProps":_vm.stepProps,"startGuideTaskSlug":_vm.task},on:{"customer-import-event":_vm.handleEvents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }